var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 80,
    viewBox: "0 0 79 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_378_961",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.37207,
    y: 0.870117,
    width: 78.635,
    height: 78.635,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_378_961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2968 60.8284C12.2217 58.3711 10.5562 55.668 9.30024 52.7192C8.04426 49.7704 7.25245 46.685 6.9248 43.4632H13.6415C13.9692 45.8113 14.5699 48.0639 15.4436 50.2209C16.3173 52.3779 17.4641 54.3847 18.8839 56.2414L14.2968 60.8284ZM6.9248 36.9103C7.36167 33.6884 8.18078 30.6031 9.38215 27.6543C10.5835 24.7054 12.2217 22.0024 14.2968 19.545L18.8839 24.1321C17.4641 25.9887 16.3173 27.9956 15.4436 30.1526C14.5699 32.3096 13.9692 34.5621 13.6415 36.9103H6.9248ZM36.2491 72.7875C33.0273 72.4598 29.9556 71.6817 27.0341 70.453C24.1126 69.2243 21.3958 67.5998 18.8839 65.5793L23.4709 60.8284C25.3822 62.2482 27.4027 63.4223 29.5324 64.3506C31.6621 65.2789 33.901 65.9069 36.2491 66.2346V72.7875ZM23.6348 19.545L18.8839 14.7941C21.4504 12.7737 24.2081 11.1491 27.1569 9.92042C30.1058 8.69174 33.1911 7.91358 36.4129 7.58594V14.1389C34.0648 14.4665 31.8122 15.0945 29.6552 16.0228C27.4982 16.9512 25.4914 18.1252 23.6348 19.545ZM42.802 72.7875V66.2346C45.2048 65.9069 47.4846 65.2926 49.6417 64.3916C51.7987 63.4905 53.8328 62.3028 55.7441 60.8284L60.4949 65.5793C57.9284 67.6544 55.157 69.2926 52.1809 70.494C49.2048 71.6953 46.0785 72.4598 42.802 72.7875ZM55.9079 19.545C53.9966 18.1252 51.9488 16.9512 49.7645 16.0228C47.5802 15.0945 45.314 14.4665 42.9659 14.1389V7.58594C46.1877 7.91358 49.2867 8.69174 52.2628 9.92042C55.2389 11.1491 57.983 12.7737 60.4949 14.7941L55.9079 19.545ZM65.082 60.8284L60.4949 56.2414C61.9147 54.3847 63.0615 52.3779 63.9352 50.2209C64.8089 48.0639 65.4096 45.8113 65.7373 43.4632H72.454C72.0171 46.685 71.198 49.7704 69.9967 52.7192C68.7953 55.668 67.1571 58.3711 65.082 60.8284ZM65.7373 36.9103C65.4096 34.5621 64.8089 32.3096 63.9352 30.1526C63.0615 27.9956 61.9147 25.9887 60.4949 24.1321L65.082 19.545C67.1571 22.0024 68.8226 24.7054 70.0786 27.6543C71.3345 30.6031 72.1264 33.6884 72.454 36.9103H65.7373ZM36.4949 56.569V36.3369L27.9761 44.8557L23.389 40.1867L39.7713 23.8044L56.1536 40.1867L51.4847 44.7738L43.0478 36.3369V56.569H36.4949Z",
    fill: "#2E62AC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.d4bc0392349358874daebfdb87670471.svg";
export { ForwardRef as ReactComponent };